export const products = [
  {
    id: 1,
    name: 'Wireless Headphones',
    description: 'Premium sound quality with noise cancellation',
    price: 129.99,
    image: '/images/headphones.jpg',
  },
  {
    id: 2,
    name: 'Ultra-Thin Laptop',
    description: 'Powerful performance in a lightweight design',
    price: 899.99,
    image: '/images/laptop.jpg',
  },
  {
    id: 3,
    name: 'Running Shoes',
    description: 'Comfortable shoes for your active lifestyle',
    price: 89.99,
    image: '/images/shoes.jpg',
  },
  {
    id: 4,
    name: 'Premium T-Shirt',
    description: '100% cotton comfortable t-shirt',
    price: 29.99,
    image: '/images/tshirt.jpg',
  },
];